import React, { useCallback, useEffect, useState } from "react";

const getScreenDetails = (window as any).getScreenDetails;

const ScreenDetails = () => {
  const [screenDetails, setScreenDetails] = useState<any | undefined>();

  const requestDetails = useCallback(() => {
    if (!getScreenDetails) return;
    getScreenDetails().then((details: any) => {
      setScreenDetails(details);
    });
  }, []);

  return (
    <>
      <h2>Screen Details</h2>
      {!screenDetails && (
        <button disabled={!getScreenDetails} onClick={requestDetails}>
          Request Screen Details
        </button>
      )}
      {!getScreenDetails && (
        <p>
          <small>This device does not support getting screen details.</small>
        </p>
      )}
      {!!screenDetails && (
        <div className="card-deck">
          {screenDetails.screens.map((screen: any) => (
            <div className="card">
              <h3>{screen?.label}</h3>
              <div className="subtitle">
                {screen.isPrimary ? "Primary" : "Secondary"}
              </div>
              <div style={{ whiteSpace: "wrap", wordBreak: "break-all" }}>
                <small>
                  {screen?.width} * {screen.height}
                </small>
                <br />
                <small>Pixel ratio: {screen.devicePixelRatio}</small>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ScreenDetails;
